import React from "react";

import CampaignDetailList from "../components/CampaignDetailList";

function CampaignDetailPage() {
  return (
    <div className="md:flex md:justify-center">
      <div className="p-3 md:flex md:flex-row">
        <CampaignDetailList />
      </div>
    </div>
  );
}

export default CampaignDetailPage;
